import { use100vh } from "react-div-100vh";
import Nav from "@/components/common/Nav";
import PageHead from "@/components/common/PageHead";
import Button from "@/components/homepage/Button";
import { useRouter } from "next/router";

const benefits = [
  {
    name: "Token",
    icon: "/assets/network/validator-benefits-1.png",
  },
  {
    name: "Community",
    icon: "/assets/network/validator-benefits-2.png",
  },
  {
    name: "Karats",
    icon: "/assets/network/validator-benefits-3.png",
  },
];

const plans = [
  {
    date: "March",
    desc: `Karat met some great people in ETH Denver!
    She gathered all the warriors that applied to fight for the project and she gave out honorary medals for the best mates.`,
    icon: "/assets/network/validator-plan-march.png",
  },
  {
    date: "April",
    desc: `Karat find her friends who end up helping her spreading the callout for her big rocket project!
    Kucoin, OKX, Bitmart and other friends will start actions immediately to support.`,
    icon: "/assets/network/validator-plan-april.png",
  },
  {
    date: "May",
    desc: `Collect the boarding pass by verifying and claiming your Karat ID. 
          Get ready for the launch!`,
    icon: "/assets/network/validator-plan-may.png",
  },
];

const Page = () => {
  const height = use100vh();
  const router = useRouter();

  const textStyle = {
    background: "linear-gradient(68.25deg, #6663F6 -2.3%, #EF8437 77.06%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  return (
    <div
      style={{
        height: height ? `${height}px` : "100vh",
      }}
      id="container"
      className="w-screen overflow-x-hidden overflow-y-scroll text-base bg-white font-exo"
    >
      <PageHead></PageHead>
      <Nav></Nav>
      <div className="bg-validatorHeroBg bg-cover pt-16 sm:pt-[118px] px-6  sm:px-20 pb-20 sm:pb-20">
        <div className="relative bg-cover rounded-lg bg-validatorHeroBg1 sm:rounded-xl">
          <div className="relative flex justify-center">
            <img
              src="/assets/network/validator-rabbit.png"
              className="hidden sm:block w-[43%] -mt-[40px] "
            ></img>
            <div className="flex flex-col items-center justify-center p-5 sm:p-0">
              <div
                className="text-center selection:text-fill-white font-extrabold text-3xl sm:text-[56px] leading-tight z-10"
                style={{
                  background:
                    "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Become a Validator
              </div>
              <div className="mt-4 text-center max-w-[445px]">
                Buy a pass to become a validator in the KARAT network. As a
                validator, you’ll be an early contributor and pioneer to the
                network with very important functions.{" "}
              </div>
              <div className="flex items-center justify-center gap-10 sm:gap-[72px] mt-12">
                <div className="flex flex-col items-center">
                  <div className="text-[22px] sm:text-[36px] text-dark1 font-extrabold">
                    0.2ETH
                  </div>
                  <div className="text-[14px] sm:text-[20px] font-medium mt-3">
                    Mint price
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <div className="text-[22px] sm:text-[36px] text-dark1 font-extrabold">
                    300
                  </div>
                  <div className="text-[14px] sm:text-[20px] font-medium mt-3">
                    Supply
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <div className="text-[22px] sm:text-[36px] text-dark1 font-extrabold">
                    05/04
                  </div>
                  <div className="text-[14px] sm:text-[20px] font-medium mt-3">
                    Mint date
                  </div>
                </div>
              </div>
              <Button
                onClick={() => {
                  router.push("/mint/validator");
                }}
                className="mt-12 font-semibold"
              >
                Mint
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center mt-[20px] sm:mt-[86px] px-5">
        <img
          src="/assets/network/validator-logo.png"
          className="max-w-[715px] w-full"
        ></img>
        <div className="mt-8 font-medium text-dark1">
          Join those who have already onboarded
        </div>
      </div>
      <div className="relative before:opacity-40 before:bg-blend before:bg-cover before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full">
        {/* benefits */}
        <div className="mt-[120px] sm:mt-[173px] px-5 sm:px-[120px]">
          <div className="relative max-w-[1200px] mx-auto">
            <img
              src="/assets/network/verifier-join-bg.png"
              className="w-full h-[300px] sm:h-[443px]"
            ></img>
            <div className="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full">
              <div
                className="selection:text-fill-white font-extrabold text-3xl sm:text-[48px] leading-tight z-10"
                style={{
                  background:
                    "linear-gradient(180deg, #87B5FF 0%, #ADB5FF 100%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Benefits
              </div>
              <div className="flex items-center gap-5 sm:gap-[80px] mt-5 sm:mt-10">
                {benefits.map((item, index) => {
                  return (
                    <div className="flex flex-col items-center" key={index}>
                      <div
                        className="w-[70px] h-[70px] sm:w-[196px] sm:h-[196px] flex items-center justify-center rounded-full"
                        style={{
                          background: "rgba(255, 255, 255, 0.2)",
                          backdropFilter: "blur(5.72px)",
                        }}
                      >
                        <img
                          className="w-[60px] h-[60px] sm:w-[173px] sm:h-[173px]"
                          src={item.icon}
                        ></img>
                      </div>

                      <div className="mt-6 font-medium text-white text:base sm:text-xl">
                        {item.name}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {/* plans */}
        <div className="mt-[120px] sm:mt-[228px] px-5 sm:px-[184px] pb-[257px]">
          <div className="max-w-[1200px] mx-auto">
            <div
              className="selection:text-fill-white font-extrabold text-3xl sm:text-[48px] leading-tight z-10"
              style={{
                background:
                  "linear-gradient(94.94deg, #0E0909 5.6%, #000000 5.61%, #676767 86.73%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Our next plans
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-[180px] sm:gap-[55px] mt-12">
              {plans.map((plan, index) => {
                return (
                  <div
                    className="bg-[#FCFCFF] px-7 pt-[50px] pb-[143px] border-gradient"
                    key={index}
                  >
                    <div className="text-[32px] text-dark1 font-semibold">
                      {plan.date}
                    </div>
                    <div className="mt-4 whitespace-pre-line">{plan.desc}</div>
                    <div className="absolute -bottom-[130px] left-0 w-full flex justify-center">
                      <img
                        className="w-[90%] max-w-[250px]"
                        src={plan.icon}
                      ></img>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page;
